import { createRestSlice } from "./restSlice";

export type Agent = {
  id: string;
  userId: string;
  organizationId: string;
  name: string;
  description: string;
  telephonyId: string | null;
  imageUrl: string | null;
  defaultVoiceId: string;
  strategy: string;
  createdAt: string;
  updatedAt: string;
  lastActivityAt: string | null;
  deletedAt: string | null;
};

const agentSlice = createRestSlice<Agent>("agent", "/v1/agents");

export const agentActions = agentSlice.actions;
export const agentReducer = agentSlice.reducer;
